module.exports = __webpack_public_path__ + "assets/img/diarybook.cc6ff45f.svg";